(window["webpackJsonpmeg_ui"] = window["webpackJsonpmeg_ui"] || []).push([["index~modal"],{

/***/ 45:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXTERNAL MODULE: external "classnames"
var external_classnames_ = __webpack_require__(2);
var external_classnames_default = /*#__PURE__*/__webpack_require__.n(external_classnames_);

// EXTERNAL MODULE: ./node_modules/babel-helper-vue-jsx-merge-props/index.js
var babel_helper_vue_jsx_merge_props = __webpack_require__(3);
var babel_helper_vue_jsx_merge_props_default = /*#__PURE__*/__webpack_require__.n(babel_helper_vue_jsx_merge_props);

// EXTERNAL MODULE: ./src/utils/props_util.js
var props_util = __webpack_require__(1);

// EXTERNAL MODULE: ./src/utils/key_code.js
var key_code = __webpack_require__(9);

// EXTERNAL MODULE: ./src/base/vc-util/Dom/contains.js
var contains = __webpack_require__(35);

// EXTERNAL MODULE: ./src/utils/vue_types/index.js + 1 modules
var vue_types = __webpack_require__(0);

// CONCATENATED MODULE: ./src/base/vc-dialog/LazyRenderBox.jsx


var ILazyRenderBoxPropTypes = {
  visible: vue_types["a" /* default */].bool,
  hiddenClassName: vue_types["a" /* default */].string,
  forceRender: vue_types["a" /* default */].bool
};
/* harmony default export */ var LazyRenderBox = ({
  props: ILazyRenderBoxPropTypes,
  render: function render() {
    var h = arguments[0];
    return h("div", {
      on: Object(props_util["getListeners"])(this)
    }, [this.$slots.default]);
  }
});
// EXTERNAL MODULE: ./src/utils/BaseMixin.js
var BaseMixin = __webpack_require__(4);

// EXTERNAL MODULE: ./src/utils/getTransitionProps.js
var getTransitionProps = __webpack_require__(22);

// CONCATENATED MODULE: ./src/utils/getScrollBarSize.js
var cached;
function getScrollBarSize(fresh) {
  if (fresh || cached === undefined) {
    var inner = document.createElement('div');
    inner.style.width = '100%';
    inner.style.height = '200px';
    var outer = document.createElement('div');
    var outerStyle = outer.style;
    outerStyle.position = 'absolute';
    outerStyle.top = 0;
    outerStyle.left = 0;
    outerStyle.pointerEvents = 'none';
    outerStyle.visibility = 'hidden';
    outerStyle.width = '200px';
    outerStyle.height = '150px';
    outerStyle.overflow = 'hidden';
    outer.appendChild(inner);
    document.body.appendChild(outer);
    var widthContained = inner.offsetWidth;
    outer.style.overflow = 'scroll';
    var widthScroll = inner.offsetWidth;

    if (widthContained === widthScroll) {
      widthScroll = outer.clientWidth;
    }

    document.body.removeChild(outer);
    cached = widthContained - widthScroll;
  }

  return cached;
}
// CONCATENATED MODULE: ./src/utils/switchScrollingEffect.js

/* harmony default export */ var utils_switchScrollingEffect = (function (close) {
  var bodyIsOverflowing = document.body.scrollHeight > (window.innerHeight || document.documentElement.clientHeight) && window.innerWidth > document.body.offsetWidth;

  if (!bodyIsOverflowing) {
    return;
  }

  if (close) {
    document.body.style.position = '';
    document.body.style.width = '';
    return;
  }

  var scrollBarSize = getScrollBarSize();

  if (scrollBarSize) {
    document.body.style.position = 'relative';
    document.body.style.width = "calc(100% - ".concat(scrollBarSize, "px)");
  }
});
// CONCATENATED MODULE: ./src/base/vc-dialog/IDialogPropTypes.js


function IDialogPropTypes() {
  return {
    keyboard: vue_types["a" /* default */].bool,
    mask: vue_types["a" /* default */].bool,
    afterClose: vue_types["a" /* default */].func,
    // onClose: PropTypes. (e: SyntheticEvent<HTMLDivElement>) =>any,
    closable: vue_types["a" /* default */].bool,
    maskClosable: vue_types["a" /* default */].bool,
    visible: vue_types["a" /* default */].bool,
    destroyOnClose: vue_types["a" /* default */].bool,
    mousePosition: vue_types["a" /* default */].shape({
      x: vue_types["a" /* default */].number,
      y: vue_types["a" /* default */].number
    }).loose,
    title: vue_types["a" /* default */].any,
    footer: vue_types["a" /* default */].any,
    transitionName: vue_types["a" /* default */].string,
    maskTransitionName: vue_types["a" /* default */].string,
    animation: vue_types["a" /* default */].any,
    maskAnimation: vue_types["a" /* default */].any,
    wrapStyle: vue_types["a" /* default */].object,
    bodyStyle: vue_types["a" /* default */].object,
    maskStyle: vue_types["a" /* default */].object,
    prefixCls: vue_types["a" /* default */].string,
    wrapClassName: vue_types["a" /* default */].string,
    width: vue_types["a" /* default */].oneOfType([vue_types["a" /* default */].string, vue_types["a" /* default */].number]),
    height: vue_types["a" /* default */].oneOfType([vue_types["a" /* default */].string, vue_types["a" /* default */].number]),
    zIndex: vue_types["a" /* default */].number,
    bodyProps: vue_types["a" /* default */].any,
    maskProps: vue_types["a" /* default */].any,
    wrapProps: vue_types["a" /* default */].any,
    getContainer: vue_types["a" /* default */].any,
    dialogStyle: vue_types["a" /* default */].object.def(function () {
      return {};
    }),
    dialogClass: vue_types["a" /* default */].string.def(''),
    closeIcon: vue_types["a" /* default */].any,
    forceRender: vue_types["a" /* default */].bool,
    getOpenCount: vue_types["a" /* default */].func,
    // https://github.com/ant-design/ant-design/issues/19771
    // https://github.com/react-component/dialog/issues/95
    focusTriggerAfterClose: vue_types["a" /* default */].bool
  };
}

/* harmony default export */ var vc_dialog_IDialogPropTypes = (IDialogPropTypes);
// CONCATENATED MODULE: ./src/base/vc-dialog/Dialog.jsx






function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }









var Dialog_IDialogPropTypes = vc_dialog_IDialogPropTypes();
var uuid = 0;

function noop() {}

function getScroll(w, top) {
  var ret = w["page".concat(top ? "Y" : "X", "Offset")];
  var method = "scroll".concat(top ? "Top" : "Left");

  if (typeof ret !== "number") {
    var d = w.document;
    ret = d.documentElement[method];

    if (typeof ret !== "number") {
      ret = d.body[method];
    }
  }

  return ret;
}

function setTransformOrigin(node, value) {
  var style = node.style;
  ["Webkit", "Moz", "Ms", "ms"].forEach(function (prefix) {
    style["".concat(prefix, "TransformOrigin")] = value;
  });
  style.transformOrigin = value;
}

function offset(el) {
  var rect = el.getBoundingClientRect();
  var pos = {
    left: rect.left,
    top: rect.top
  };
  var doc = el.ownerDocument;
  var w = doc.defaultView || doc.parentWindow;
  pos.left += getScroll(w);
  pos.top += getScroll(w, true);
  return pos;
}

var cacheOverflow = {};
/* harmony default export */ var Dialog = ({
  mixins: [BaseMixin["a" /* default */]],
  props: Object(props_util["initDefaultProps"])(Dialog_IDialogPropTypes, {
    mask: true,
    visible: false,
    keyboard: true,
    closable: true,
    maskClosable: true,
    destroyOnClose: false,
    prefixCls: "rc-dialog",
    getOpenCount: function getOpenCount() {
      return null;
    },
    focusTriggerAfterClose: true
  }),
  data: function data() {
    return {
      destroyPopup: false
    };
  },
  provide: function provide() {
    return {
      dialogContext: this
    };
  },
  watch: {
    visible: function visible(val) {
      var _this = this;

      if (val) {
        this.destroyPopup = false;
      }

      this.$nextTick(function () {
        _this.updatedCallback(!val);
      });
    }
  },
  beforeMount: function beforeMount() {
    this.inTransition = false;
    this.titleId = "rcDialogTitle".concat(uuid++);
  },
  mounted: function mounted() {
    var _this2 = this;

    this.$nextTick(function () {
      _this2.updatedCallback(false); // if forceRender is true, set element style display to be none;


      if ((_this2.forceRender || _this2.getContainer === false && !_this2.visible) && _this2.$refs.wrap) {
        _this2.$refs.wrap.style.display = "none";
      }
    });
  },
  beforeDestroy: function beforeDestroy() {
    var visible = this.visible,
        getOpenCount = this.getOpenCount;

    if ((visible || this.inTransition) && !getOpenCount()) {
      this.switchScrollingEffect();
    }

    clearTimeout(this.timeoutId);
  },
  methods: {
    // 对外暴露的 api 不要更改名称或删除
    getDialogWrap: function getDialogWrap() {
      return this.$refs.wrap;
    },
    updatedCallback: function updatedCallback(visible) {
      var mousePosition = this.mousePosition;
      var mask = this.mask,
          focusTriggerAfterClose = this.focusTriggerAfterClose;

      if (this.visible) {
        // first show
        if (!visible) {
          this.openTime = Date.now(); // this.lastOutSideFocusNode = document.activeElement

          this.switchScrollingEffect(); // this.$refs.wrap.focus()

          this.tryFocus();
          var dialogNode = this.$refs.dialog.$el;

          if (mousePosition) {
            var elOffset = offset(dialogNode);
            setTransformOrigin(dialogNode, "".concat(mousePosition.x - elOffset.left, "px ").concat(mousePosition.y - elOffset.top, "px"));
          } else {
            setTransformOrigin(dialogNode, "");
          }
        }
      } else if (visible) {
        this.inTransition = true;

        if (mask && this.lastOutSideFocusNode && focusTriggerAfterClose) {
          try {
            this.lastOutSideFocusNode.focus();
          } catch (e) {
            this.lastOutSideFocusNode = null;
          }

          this.lastOutSideFocusNode = null;
        }
      }
    },
    tryFocus: function tryFocus() {
      if (!Object(contains["a" /* default */])(this.$refs.wrap, document.activeElement)) {
        this.lastOutSideFocusNode = document.activeElement;
        this.$refs.sentinelStart.focus();
      }
    },
    // 动画钩子行为,设置过渡离开完成之后的组件状态
    // onAnimateEnter() {
    //     console.log('node animate enter');
    // },
    onAnimateLeave: function onAnimateLeave(el) {
      // console.log('node animate leave');
      var afterClose = this.afterClose,
          destroyOnClose = this.destroyOnClose;

      if (this.$refs.wrap) {
        this.$refs.wrap.style.display = "none";
      }

      if (destroyOnClose) {
        this.destroyPopup = true;
      }

      this.inTransition = false;
      this.switchScrollingEffect();

      if (afterClose) {
        afterClose();
      }
    },
    onDialogMouseDown: function onDialogMouseDown() {
      this.dialogMouseDown = true;
    },
    onMaskMouseUp: function onMaskMouseUp() {
      var _this3 = this;

      if (this.dialogMouseDown) {
        this.timeoutId = setTimeout(function () {
          _this3.dialogMouseDown = false;
        }, 0);
      }
    },
    onMaskClick: function onMaskClick(e) {
      // android trigger click on open (fastclick??)
      if (Date.now() - this.openTime < 300) {
        return;
      }

      if (e.target === e.currentTarget && !this.dialogMouseDown) {
        this.close(e);
      }
    },
    onKeydown: function onKeydown(e) {
      var props = this.$props;

      if (props.keyboard && e.keyCode === key_code["a" /* default */].ESC) {
        e.stopPropagation();
        this.close(e);
        return;
      } // keep focus inside dialog


      if (props.visible) {
        if (e.keyCode === key_code["a" /* default */].TAB) {
          var activeElement = document.activeElement;
          var sentinelStart = this.$refs.sentinelStart;

          if (e.shiftKey) {
            if (activeElement === sentinelStart) {
              this.$refs.sentinelEnd.focus();
            }
          } else if (activeElement === this.$refs.sentinelEnd) {
            sentinelStart.focus();
          }
        }
      }
    },
    getDialogElement: function getDialogElement() {
      var h = this.$createElement;
      var closable = this.closable,
          prefixCls = this.prefixCls,
          width = this.width,
          height = this.height,
          title = this.title,
          tempFooter = this.footer,
          bodyStyle = this.bodyStyle,
          visible = this.visible,
          bodyProps = this.bodyProps,
          forceRender = this.forceRender,
          dialogStyle = this.dialogStyle,
          dialogClass = this.dialogClass;

      var dest = _objectSpread({}, dialogStyle);

      if (width !== undefined) {
        dest.width = typeof width === "number" ? "".concat(width, "px") : width;
      }

      if (height !== undefined) {
        dest.height = typeof height === "number" ? "".concat(height, "px") : height;
      }

      var footer;

      if (tempFooter) {
        footer = h("div", {
          key: "footer",
          "class": "".concat(prefixCls, "-footer"),
          ref: "footer"
        }, [tempFooter]);
      }

      var header;

      if (title) {
        header = h("div", {
          key: "header",
          "class": "".concat(prefixCls, "-header"),
          ref: "header"
        }, [h("div", {
          "class": "".concat(prefixCls, "-title"),
          attrs: {
            id: this.titleId
          }
        }, [title])]);
      }

      var closer;

      if (closable) {
        var closeIcon = Object(props_util["getComponentFromProp"])(this, "closeIcon");
        closer = h("button", {
          attrs: {
            type: "button",
            "aria-label": "Close"
          },
          key: "close",
          on: {
            "click": this.close || noop
          },
          "class": "".concat(prefixCls, "-close")
        }, [closeIcon || h("span", {
          "class": "".concat(prefixCls, "-close-x")
        })]);
      }

      var style = dest;
      var sentinelStyle = {
        width: 0,
        height: 0,
        overflow: "hidden"
      };

      var cls = _defineProperty({}, prefixCls, true);

      var transitionName = this.getTransitionName();
      var dialogElement = h(LazyRenderBox, {
        directives: [{
          name: "show",
          value: visible
        }],
        key: "dialog-element",
        attrs: {
          role: "document",
          forceRender: forceRender
        },
        ref: "dialog",
        style: style,
        "class": [cls, dialogClass],
        on: {
          "mousedown": this.onDialogMouseDown
        }
      }, [h("div", {
        attrs: {
          tabIndex: 0,
          "aria-hidden": "true"
        },
        ref: "sentinelStart",
        style: sentinelStyle
      }), h("div", {
        "class": "".concat(prefixCls, "-content")
      }, [closer, header, h("div", babel_helper_vue_jsx_merge_props_default()([{
        key: "body",
        "class": "".concat(prefixCls, "-body"),
        style: bodyStyle,
        ref: "body"
      }, bodyProps]), [this.$slots.default]), footer]), h("div", {
        attrs: {
          tabIndex: 0,
          "aria-hidden": "true"
        },
        ref: "sentinelEnd",
        style: sentinelStyle
      })]);
      var dialogTransitionProps = Object(getTransitionProps["a" /* default */])(transitionName, {
        afterLeave: this.onAnimateLeave
      });
      return h("transition", babel_helper_vue_jsx_merge_props_default()([{
        key: "modal"
      }, dialogTransitionProps]), [visible || !this.destroyPopup ? dialogElement : null]);
    },
    getZIndexStyle: function getZIndexStyle() {
      var style = {};
      var props = this.$props;

      if (props.zIndex !== undefined) {
        style.zIndex = props.zIndex;
      }

      return style;
    },
    getWrapStyle: function getWrapStyle() {
      return _objectSpread(_objectSpread({}, this.getZIndexStyle()), this.wrapStyle);
    },
    getMaskStyle: function getMaskStyle() {
      return _objectSpread(_objectSpread({}, this.getZIndexStyle()), this.maskStyle);
    },
    getMaskElement: function getMaskElement() {
      var h = this.$createElement;
      var props = this.$props;
      var maskElement;

      if (props.mask) {
        var maskTransition = this.getMaskTransitionName();
        maskElement = h(LazyRenderBox, babel_helper_vue_jsx_merge_props_default()([{
          directives: [{
            name: "show",
            value: props.visible
          }],
          style: this.getMaskStyle(),
          key: "mask",
          "class": "".concat(props.prefixCls, "-mask")
        }, props.maskProps])); // 暂时先去掉动画效果

        if (maskTransition) {
          var maskTransitionProps = Object(getTransitionProps["a" /* default */])(maskTransition);
          maskElement = h("transition", babel_helper_vue_jsx_merge_props_default()([{
            key: "mask"
          }, maskTransitionProps]), [maskElement]);
        }
      }

      return maskElement;
    },
    getMaskTransitionName: function getMaskTransitionName() {
      var props = this.$props;
      var transitionName = props.maskTransitionName;
      var animation = props.maskAnimation;

      if (!transitionName && animation) {
        transitionName = "".concat(props.prefixCls, "-").concat(animation);
      }

      return transitionName;
    },
    getTransitionName: function getTransitionName() {
      var props = this.$props;
      var transitionName = props.transitionName;
      var animation = props.animation;

      if (!transitionName && animation) {
        transitionName = "".concat(props.prefixCls, "-").concat(animation);
      }

      return transitionName;
    },
    // setScrollbar() {
    //   if (this.bodyIsOverflowing && this.scrollbarWidth !== undefined) {
    //     document.body.style.paddingRight = `${this.scrollbarWidth}px`;
    //   }
    // },
    switchScrollingEffect: function switchScrollingEffect() {
      var getOpenCount = this.getOpenCount;
      var openCount = getOpenCount();

      if (openCount === 1) {
        if (cacheOverflow.hasOwnProperty("overflowX")) {
          return;
        }

        cacheOverflow = {
          overflowX: document.body.style.overflowX,
          overflowY: document.body.style.overflowY,
          overflow: document.body.style.overflow
        };

        utils_switchScrollingEffect(); // Must be set after switchScrollingEffect


        document.body.style.overflow = "hidden";
      } else if (!openCount) {
        // IE browser doesn't merge overflow style, need to set it separately
        if (cacheOverflow.overflow !== undefined) {
          document.body.style.overflow = cacheOverflow.overflow;
        }

        if (cacheOverflow.overflowX !== undefined) {
          document.body.style.overflowX = cacheOverflow.overflowX;
        }

        if (cacheOverflow.overflowY !== undefined) {
          document.body.style.overflowY = cacheOverflow.overflowY;
        }

        cacheOverflow = {};

        utils_switchScrollingEffect(true);
      }
    },
    // removeScrollingEffect() {
    //   const { getOpenCount } = this;
    //   const openCount = getOpenCount();
    //   if (openCount !== 0) {
    //     return;
    //   }
    //   document.body.style.overflow = '';
    //   switchScrollingEffect(true);
    //   // this.resetAdjustments();
    // },
    close: function close(e) {
      this.__emit("close", e);
    }
  },
  render: function render() {
    var h = arguments[0];
    var prefixCls = this.prefixCls,
        maskClosable = this.maskClosable,
        visible = this.visible,
        wrapClassName = this.wrapClassName,
        title = this.title,
        wrapProps = this.wrapProps;
    var style = this.getWrapStyle();

    if (visible) {
      style.display = null;
    }

    return h("div", {
      "class": "".concat(prefixCls, "-root")
    }, [this.getMaskElement(), h("div", babel_helper_vue_jsx_merge_props_default()([{
      attrs: {
        tabIndex: -1,
        role: "dialog",
        "aria-labelledby": title ? this.titleId : null
      },
      on: {
        "keydown": this.onKeydown,
        "click": maskClosable ? this.onMaskClick : noop,
        "mouseup": maskClosable ? this.onMaskMouseUp : noop
      },
      "class": "".concat(prefixCls, "-wrap ").concat(wrapClassName || ""),
      ref: "wrap",
      style: style
    }, wrapProps]), [this.getDialogElement()])]);
  }
});
// CONCATENATED MODULE: ./src/utils/setStyle.js
/**
 * Easy to set element style, return previous style
 * IE browser compatible(IE browser doesn't merge overflow style, need to set it separately)
 * https://github.com/ant-design/ant-design/issues/19393
 *
 */
function setStyle(style) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var _options$element = options.element,
      element = _options$element === void 0 ? document.body : _options$element;
  var oldStyle = {};
  var styleKeys = Object.keys(style); // IE browser compatible

  styleKeys.forEach(function (key) {
    oldStyle[key] = element.style[key];
  });
  styleKeys.forEach(function (key) {
    element.style[key] = style[key];
  });
  return oldStyle;
}

/* harmony default export */ var utils_setStyle = (setStyle);
// EXTERNAL MODULE: ./src/utils/vnode.js
var vnode = __webpack_require__(7);

// CONCATENATED MODULE: ./src/utils/Portal.js


/* harmony default export */ var Portal = ({
  name: 'Portal',
  props: {
    getContainer: vue_types["a" /* default */].func.isRequired,
    children: vue_types["a" /* default */].any.isRequired,
    didUpdate: vue_types["a" /* default */].func
  },
  mounted: function mounted() {
    this.createContainer();
  },
  updated: function updated() {
    var _this = this;

    var didUpdate = this.$props.didUpdate;

    if (didUpdate) {
      this.$nextTick(function () {
        didUpdate(_this.$props);
      });
    }
  },
  beforeDestroy: function beforeDestroy() {
    this.removeContainer();
  },
  methods: {
    createContainer: function createContainer() {
      this._container = this.$props.getContainer();
      this.$forceUpdate();
    },
    removeContainer: function removeContainer() {
      if (this._container && this._container.parentNode) {
        this._container.parentNode.removeChild(this._container);
      }
    }
  },
  render: function render() {
    if (this._container) {
      return Object(vnode["a" /* cloneElement */])(this.$props.children, {
        directives: [{
          name: 'meg-portal',
          value: this._container
        }]
      });
    }

    return null;
  }
});
// CONCATENATED MODULE: ./src/utils/PortalWrapper.js


function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }





var PortalWrapper_openCount = 0;
var windowIsUndefined = !(typeof window !== 'undefined' && window.document && window.document.createElement); // https://github.com/ant-design/ant-design/issues/19340
// https://github.com/ant-design/ant-design/issues/19332

var PortalWrapper_cacheOverflow = {};
/* harmony default export */ var PortalWrapper = ({
  name: 'PortalWrapper',
  props: {
    wrapperClassName: vue_types["a" /* default */].string,
    forceRender: vue_types["a" /* default */].bool,
    getContainer: vue_types["a" /* default */].any,
    children: vue_types["a" /* default */].func,
    visible: vue_types["a" /* default */].bool
  },
  data: function data() {
    var visible = this.$props.visible;
    PortalWrapper_openCount = visible ? PortalWrapper_openCount + 1 : PortalWrapper_openCount;
    return {};
  },
  updated: function updated() {
    this.setWrapperClassName();
  },
  watch: {
    visible: function visible(val) {
      PortalWrapper_openCount = val ? PortalWrapper_openCount + 1 : PortalWrapper_openCount - 1;
    },
    getContainer: function getContainer(_getContainer, prevGetContainer) {
      var getContainerIsFunc = typeof _getContainer === 'function' && typeof prevGetContainer === 'function';

      if (getContainerIsFunc ? _getContainer.toString() !== prevGetContainer.toString() : _getContainer !== prevGetContainer) {
        this.removeCurrentContainer(false);
      }
    }
  },
  beforeDestroy: function beforeDestroy() {
    var visible = this.$props.visible; // 离开时不会 render， 导到离开时数值不变，改用 func 。。

    PortalWrapper_openCount = visible && PortalWrapper_openCount ? PortalWrapper_openCount - 1 : PortalWrapper_openCount;
    this.removeCurrentContainer(visible);
  },
  methods: {
    getParent: function getParent() {
      var getContainer = this.$props.getContainer;

      if (getContainer) {
        if (typeof getContainer === 'string') {
          return document.querySelectorAll(getContainer)[0];
        }

        if (typeof getContainer === 'function') {
          return getContainer();
        }

        if (_typeof(getContainer) === 'object' && getContainer instanceof window.HTMLElement) {
          return getContainer;
        }
      }

      return document.body;
    },
    getDomContainer: function getDomContainer() {
      if (windowIsUndefined) {
        return null;
      }

      if (!this.container) {
        this.container = document.createElement('div');
        var parent = this.getParent();

        if (parent) {
          parent.appendChild(this.container);
        }
      }

      this.setWrapperClassName();
      return this.container;
    },
    setWrapperClassName: function setWrapperClassName() {
      var wrapperClassName = this.$props.wrapperClassName;

      if (this.container && wrapperClassName && wrapperClassName !== this.container.className) {
        this.container.className = wrapperClassName;
      }
    },
    savePortal: function savePortal(c) {
      // Warning: don't rename _component
      // https://github.com/react-component/util/pull/65#discussion_r352407916
      this._component = c;
    },
    removeCurrentContainer: function removeCurrentContainer() {
      this.container = null;
      this._component = null;
    },

    /**
     * Enhance ./switchScrollingEffect
     * 1. Simulate document body scroll bar with
     * 2. Record body has overflow style and recover when all of PortalWrapper invisible
     * 3. Disable body scroll when PortalWrapper has open
     *
     * @memberof PortalWrapper
     */
    switchScrollingEffect: function switchScrollingEffect() {
      if (PortalWrapper_openCount === 1 && !Object.keys(PortalWrapper_cacheOverflow).length) {
        utils_switchScrollingEffect(); // Must be set after switchScrollingEffect


        PortalWrapper_cacheOverflow = utils_setStyle({
          overflow: 'hidden',
          overflowX: 'hidden',
          overflowY: 'hidden'
        });
      } else if (!PortalWrapper_openCount) {
        utils_setStyle(PortalWrapper_cacheOverflow);
        PortalWrapper_cacheOverflow = {};

        utils_switchScrollingEffect(true);
      }
    }
  },
  render: function render() {
    var h = arguments[0];
    var _this$$props = this.$props,
        children = _this$$props.children,
        forceRender = _this$$props.forceRender,
        visible = _this$$props.visible;
    var portal = null;
    var childProps = {
      getOpenCount: function getOpenCount() {
        return PortalWrapper_openCount;
      },
      getContainer: this.getDomContainer,
      switchScrollingEffect: this.switchScrollingEffect
    };

    if (forceRender || visible || this._component) {
      portal = h(Portal, babel_helper_vue_jsx_merge_props_default()([{
        attrs: {
          getContainer: this.getDomContainer,
          children: children(childProps)
        }
      }, {
        directives: [{
          name: 'meg-ref',
          value: this.savePortal
        }]
      }]));
    }

    return portal;
  }
});
// CONCATENATED MODULE: ./src/base/vc-dialog/DialogWrap.jsx


function DialogWrap_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function DialogWrap_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { DialogWrap_ownKeys(Object(source), true).forEach(function (key) { DialogWrap_defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { DialogWrap_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function DialogWrap_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }





var DialogWrap_IDialogPropTypes = vc_dialog_IDialogPropTypes();
var DialogWrap = {
  inheritAttrs: false,
  props: DialogWrap_objectSpread(DialogWrap_objectSpread({}, DialogWrap_IDialogPropTypes), {}, {
    visible: DialogWrap_IDialogPropTypes.visible.def(false)
  }),
  render: function render() {
    var _this = this;

    var h = arguments[0];
    var _this$$props = this.$props,
        visible = _this$$props.visible,
        getContainer = _this$$props.getContainer,
        forceRender = _this$$props.forceRender;
    var dialogProps = {
      props: this.$props,
      attrs: this.$attrs,
      ref: '_component',
      key: 'dialog',
      on: Object(props_util["getListeners"])(this)
    }; // 渲染在当前 dom 里；

    if (getContainer === false) {
      return h(Dialog, babel_helper_vue_jsx_merge_props_default()([dialogProps, {
        attrs: {
          getOpenCount: function getOpenCount() {
            return 2;
          } // 不对 body 做任何操作。。

        }
      }]), [this.$slots.default]);
    }

    return h(PortalWrapper, {
      attrs: {
        visible: visible,
        forceRender: forceRender,
        getContainer: getContainer,
        children: function children(childProps) {
          dialogProps.props = DialogWrap_objectSpread(DialogWrap_objectSpread({}, dialogProps.props), childProps);
          return h(Dialog, dialogProps, [_this.$slots.default]);
        }
      }
    });
  }
};
/* harmony default export */ var vc_dialog_DialogWrap = (DialogWrap);
// CONCATENATED MODULE: ./src/base/vc-dialog/index.js
// based on vc-dialog 7.5.14

/* harmony default export */ var vc_dialog = (vc_dialog_DialogWrap);
// EXTERNAL MODULE: ./src/base/vc-util/Dom/addEventListener.js
var addEventListener = __webpack_require__(26);

// EXTERNAL MODULE: ./src/components/modal/locale.js
var modal_locale = __webpack_require__(48);

// EXTERNAL MODULE: ./src/base/locale-provider/LocaleReceiver.jsx
var LocaleReceiver = __webpack_require__(15);

// EXTERNAL MODULE: ./src/base/config-provider/index.jsx + 1 modules
var config_provider = __webpack_require__(8);

// CONCATENATED MODULE: ./src/components/modal/modal.jsx
function modal_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function modal_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { modal_ownKeys(Object(source), true).forEach(function (key) { modal_defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { modal_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function modal_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }









var mousePosition = null;

var getClickPosition = function getClickPosition(e) {
  mousePosition = {
    x: e.pageX,
    y: e.pageY
  }; // 100ms 内发生过点击事件，则从点击位置动画展示
  // 否则直接 zoom 展示
  // 这样可以兼容非点击方式展开

  setTimeout(function () {
    return mousePosition = null;
  }, 100);
};

if (typeof window !== "undefined" && window.document && window.document.documentElement) {
  // only click event support transition animition
  Object(addEventListener["a" /* default */])(document.documentElement, "click", getClickPosition, true);
}

function modal_noop() {}

var modal_modalProps = function modalProps() {
  var defaultProps = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var props = {
    prefixCls: vue_types["a" /* default */].string,
    // className prefixCls
    visible: vue_types["a" /* default */].bool,
    // Modal visible
    confirmLoading: vue_types["a" /* default */].bool,
    // confirm button loading TODO: Button not support at now
    title: vue_types["a" /* default */].any,
    // Modal title
    closable: vue_types["a" /* default */].bool,
    // close icon visible
    closeIcon: vue_types["a" /* default */].any,
    // close icon
    // onOk: (e: React.MouseEvent<any>) => void,
    // onCancel: (e: React.MouseEvent<any>) => void,
    afterClose: vue_types["a" /* default */].func.def(modal_noop),
    // Modal close callback
    centered: vue_types["a" /* default */].bool,
    // modal position
    width: vue_types["a" /* default */].oneOfType([vue_types["a" /* default */].string, vue_types["a" /* default */].number]),
    // Modal width
    footer: vue_types["a" /* default */].any,
    // modal foot content
    okText: vue_types["a" /* default */].any,
    // confirm button text
    okType: vue_types["a" /* default */].string,
    // confirm button type
    cancelText: vue_types["a" /* default */].any,
    // cancel button text
    icon: vue_types["a" /* default */].any,
    // func modal icon
    maskClosable: vue_types["a" /* default */].bool,
    // click mask allow modal close
    forceRender: vue_types["a" /* default */].bool,
    // force render modal
    okButtonProps: vue_types["a" /* default */].object,
    // confirm button props
    cancelButtonProps: vue_types["a" /* default */].object,
    destroyOnClose: vue_types["a" /* default */].bool,
    // Whether to unmount child components on onClose
    wrapClassName: vue_types["a" /* default */].string,
    // class name of the container of the modal 
    maskTransitionName: vue_types["a" /* default */].string,
    transitionName: vue_types["a" /* default */].string,
    getContainer: vue_types["a" /* default */].func,
    // Return the mount ele node for Modal
    zIndex: vue_types["a" /* default */].number,
    // The z-index of the Modal
    bodyStyle: vue_types["a" /* default */].object,
    // Body style for modal body element. Such as height, padding etc.
    maskStyle: vue_types["a" /* default */].object,
    // 
    mask: vue_types["a" /* default */].bool,
    keyboard: vue_types["a" /* default */].bool,
    wrapProps: vue_types["a" /* default */].object,
    focusTriggerAfterClose: vue_types["a" /* default */].bool
  };
  return Object(props_util["initDefaultProps"])(props, defaultProps);
};

var destroyFns = []; // 销毁函数队列

/* harmony default export */ var modal = ({
  name: "MegModal",
  inheritAttrs: false,
  // v-model
  model: {
    prop: "visible",
    event: "change"
  },
  props: modal_modalProps({
    width: 520,
    transitionName: "meg-modal-fade",
    maskTransitionName: "meg-modal-mask-fade",
    confirmLoading: false,
    visible: false,
    okType: "primary"
  }),
  data: function data() {
    return {
      initVisible: !!this.visible
    };
  },
  watch: {
    visible: function visible(val) {
      this.initVisible = val;
    }
  },
  inject: {
    configProvider: {
      default: function _default() {
        return config_provider["ConfigConsumerProps"];
      }
    }
  },
  methods: {
    handleCancel: function handleCancel(e) {
      this.$emit("cancel", e);
      this.$emit("change", false);
    },
    handleOk: function handleOk(e) {
      this.$emit("ok", e);
    },
    renderFooter: function renderFooter(locale) {
      var h = this.$createElement;
      var okType = this.okType,
          confirmLoading = this.confirmLoading;
      var cancelBtnProps = Object(props_util["mergeProps"])({
        on: {
          click: this.handleCancel
        }
      }, this.cancelButtonProps || {});
      var okBtnProps = Object(props_util["mergeProps"])({
        on: {
          click: this.handleOk
        },
        props: {
          type: okType,
          loading: confirmLoading
        }
      }, this.okButtonProps || {});
      return h("div", [h("meg-button", cancelBtnProps, [Object(props_util["getComponentFromProp"])(this, "cancelText") || locale.cancelText]), h("meg-button", okBtnProps, [Object(props_util["getComponentFromProp"])(this, "okText") || locale.okText])]);
    }
  },
  render: function render() {
    var h = arguments[0];
    var customizePrefixCls = this.prefixCls,
        visible = this.initVisible,
        wrapClassName = this.wrapClassName,
        centered = this.centered,
        getContainer = this.getContainer,
        $slots = this.$slots,
        $scopedSlots = this.$scopedSlots,
        $attrs = this.$attrs;
    var children = $scopedSlots.default ? $scopedSlots.default() : $slots.default;
    var _this$configProvider = this.configProvider,
        getPrefixCls = _this$configProvider.getPrefixCls,
        getContextPopupContainer = _this$configProvider.getPopupContainer;
    var prefixCls = getPrefixCls("modal", customizePrefixCls);
    var defaultFooter = h(LocaleReceiver["a" /* default */], {
      attrs: {
        componentName: "Modal",
        defaultLocale: Object(modal_locale["a" /* changeConfirmLocale */])()
      },
      scopedSlots: {
        default: this.renderFooter
      }
    });
    var closeIcon = Object(props_util["getComponentFromProp"])(this, "closeIcon");
    var closeIconToRender = h("span", {
      "class": "".concat(prefixCls, "-close-x")
    }, [closeIcon || h("meg-icon", {
      attrs: {
        name: "megui-close",
        original: true,
        type: "close"
      },
      "class": "".concat(prefixCls, "-close-icon")
    })]);
    var footer = Object(props_util["getComponentFromProp"])(this, "footer");
    var title = Object(props_util["getComponentFromProp"])(this, "title");
    var dialogProps = {
      props: modal_objectSpread(modal_objectSpread({}, this.$props), {}, {
        getContainer: getContainer === undefined ? getContextPopupContainer : getContainer,
        prefixCls: prefixCls,
        wrapClassName: external_classnames_default()(modal_defineProperty({}, "".concat(prefixCls, "-centered"), !!centered), wrapClassName),
        title: title,
        footer: footer === undefined ? defaultFooter : footer,
        visible: visible,
        mousePosition: mousePosition,
        closeIcon: closeIconToRender
      }),
      on: modal_objectSpread(modal_objectSpread({}, Object(props_util["getListeners"])(this)), {}, {
        close: this.handleCancel
      }),
      class: Object(props_util["getClass"])(this),
      style: Object(props_util["getStyle"])(this),
      attrs: $attrs
    };
    return h(vc_dialog, dialogProps, [children]);
  }
});
// EXTERNAL MODULE: external "vue"
var external_vue_ = __webpack_require__(10);
var external_vue_default = /*#__PURE__*/__webpack_require__.n(external_vue_);

// CONCATENATED MODULE: ./src/components/modal/action-button.jsx



var ActionButtonProps = {
  type: vue_types["a" /* default */].string,
  actionFn: vue_types["a" /* default */].func,
  closeModal: vue_types["a" /* default */].func,
  autoFocus: vue_types["a" /* default */].bool,
  buttonProps: vue_types["a" /* default */].object
};
/* harmony default export */ var action_button = ({
  mixins: [BaseMixin["a" /* default */]],
  props: ActionButtonProps,
  data: function data() {
    return {
      loading: false
    };
  },
  mounted: function mounted() {
    var _this = this;

    if (this.autoFocus) {
      this.timeoutId = setTimeout(function () {
        return _this.$el.focus();
      });
    }
  },
  beforeDestroy: function beforeDestroy() {
    clearTimeout(this.timeoutId);
  },
  methods: {
    onClick: function onClick() {
      var _this2 = this;

      var actionFn = this.actionFn,
          closeModal = this.closeModal;

      if (actionFn) {
        var ret;

        if (actionFn.length) {
          ret = actionFn(closeModal);
        } else {
          ret = actionFn();

          if (!ret) {
            closeModal();
          }
        }

        if (ret && ret.then) {
          this.setState({
            loading: true
          });
          ret.then(function () {
            // It's unnecessary to set loading=false, for the Modal will be unmounted after close.
            // this.setState({ loading: false });
            closeModal.apply(void 0, arguments);
          }, function (e) {
            // Emit error when catch promise reject
            // eslint-disable-next-line no-console
            console.error(e); // See: https://github.com/ant-design/ant-design/issues/6183

            _this2.setState({
              loading: false
            });
          });
        }
      } else {
        closeModal();
      }
    }
  },
  render: function render() {
    var h = arguments[0];
    var type = this.type,
        $slots = this.$slots,
        loading = this.loading,
        buttonProps = this.buttonProps;
    return h("meg-button", babel_helper_vue_jsx_merge_props_default()([{
      attrs: {
        type: type,
        loading: loading
      },
      on: {
        "click": this.onClick
      }
    }, buttonProps]), [$slots.default]);
  }
});
// EXTERNAL MODULE: ./src/utils/warning.js + 1 modules
var utils_warning = __webpack_require__(12);

// CONCATENATED MODULE: ./src/components/modal/confirm-dialog.jsx
function confirm_dialog_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }






/* harmony default export */ var confirm_dialog = ({
  functional: true,
  render: function render(h, context) {
    var props = context.props;
    var onCancel = props.onCancel,
        onOk = props.onOk,
        close = props.close,
        zIndex = props.zIndex,
        afterClose = props.afterClose,
        visible = props.visible,
        keyboard = props.keyboard,
        centered = props.centered,
        getContainer = props.getContainer,
        maskStyle = props.maskStyle,
        okButtonProps = props.okButtonProps,
        cancelButtonProps = props.cancelButtonProps,
        _props$iconType = props.iconType,
        iconType = _props$iconType === void 0 ? "megui-fill-check-circle" : _props$iconType,
        _props$closable = props.closable,
        closable = _props$closable === void 0 ? true : _props$closable;
    Object(utils_warning["a" /* default */])(!("iconType" in props), "Modal", "The property 'iconType' is deprecated. Use the property 'icon' instead.");
    var icon = props.icon ? props.icon : iconType;
    var okType = props.okType || "primary";
    var prefixCls = props.prefixCls || "meg-modal";
    var contentPrefixCls = "".concat(prefixCls, "-confirm"); // 默认为 true，保持向下兼容

    var okCancel = "okCancel" in props ? props.okCancel : true;
    var width = props.width || 416;
    var style = props.style || {};
    var mask = props.mask === undefined ? true : props.mask; // 默认为 false，保持旧版默认行为

    var maskClosable = props.maskClosable === undefined ? false : props.maskClosable;
    var runtimeLocale = Object(modal_locale["b" /* getConfirmLocale */])();
    var okText = props.okText || (okCancel ? runtimeLocale.okText : runtimeLocale.justOkText);
    var cancelText = props.cancelText || runtimeLocale.cancelText;
    var autoFocusButton = props.autoFocusButton === null ? false : props.autoFocusButton || "ok";
    var transitionName = props.transitionName || "meg-modal-fade";
    var maskTransitionName = props.maskTransitionName || "meg-modal-mask-fade";
    var classString = external_classnames_default()(contentPrefixCls, "".concat(contentPrefixCls, "-").concat(props.type), "".concat(prefixCls, "-").concat(props.type), props.class);
    var cancelButton = okCancel && h(action_button, {
      attrs: {
        actionFn: onCancel,
        closeModal: close,
        autoFocus: autoFocusButton === "cancel",
        buttonProps: cancelButtonProps
      }
    }, [cancelText]);
    var iconNode = typeof icon === "string" ? h("meg-icon", {
      attrs: {
        name: icon,
        type: icon
      }
    }) : icon(h);
    return h(modal, {
      attrs: {
        prefixCls: prefixCls,
        wrapClassName: external_classnames_default()(confirm_dialog_defineProperty({}, "".concat(contentPrefixCls, "-centered"), !!centered)),
        visible: visible,
        closable: closable,
        title: "",
        transitionName: transitionName,
        footer: "",
        maskTransitionName: maskTransitionName,
        mask: mask,
        maskClosable: maskClosable,
        maskStyle: maskStyle,
        width: width,
        zIndex: zIndex,
        afterClose: afterClose,
        keyboard: keyboard,
        centered: centered,
        getContainer: getContainer
      },
      "class": classString,
      on: {
        "cancel": function cancel(e) {
          return close({
            triggerCancel: true
          }, e);
        }
      },
      style: style
    }, [h("div", {
      "class": "".concat(contentPrefixCls, "-body-wrapper")
    }, [h("div", {
      "class": "".concat(contentPrefixCls, "-body")
    }, [iconNode, props.title === undefined ? null : h("span", {
      "class": "".concat(contentPrefixCls, "-title")
    }, [typeof props.title === "function" ? props.title(h) : props.title]), h("div", {
      "class": "".concat(contentPrefixCls, "-content")
    }, [typeof props.content === "function" ? props.content(h) : props.content])]), h("div", {
      "class": "".concat(contentPrefixCls, "-btns")
    }, [cancelButton, h(action_button, {
      attrs: {
        type: okType,
        actionFn: onOk,
        closeModal: close,
        autoFocus: autoFocusButton === "ok",
        buttonProps: okButtonProps
      }
    }, [okText])])])]);
  }
});
// EXTERNAL MODULE: ./src/base/base/index.js
var base = __webpack_require__(19);

// EXTERNAL MODULE: ./node_modules/omit.js/es/index.js
var es = __webpack_require__(13);

// CONCATENATED MODULE: ./src/components/modal/confirm.js
function confirm_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function confirm_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { confirm_ownKeys(Object(source), true).forEach(function (key) { confirm_defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { confirm_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function confirm_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }





 // 二次确认弹框

function confirm_confirm(config) {
  var div = document.createElement("div");
  var el = document.createElement("div");
  div.appendChild(el);
  document.body.appendChild(div); // Modal Method注入的属性

  var currentConfig = confirm_objectSpread(confirm_objectSpread({}, Object(es["a" /* default */])(config, ["parentContext"])), {}, {
    close: close,
    visible: true
  });

  var confirmDialogInstance = null;
  var confirmDialogProps = {
    props: {}
  };

  function update(newConfig) {
    currentConfig = confirm_objectSpread(confirm_objectSpread({}, currentConfig), newConfig);
    confirmDialogInstance && Object.assign(confirmDialogInstance, {
      confirmDialogProps: {
        props: currentConfig
      }
    });
  }

  function destroy() {
    if (confirmDialogInstance && div.parentNode) {
      confirmDialogInstance.vIf = false; // to fix confirm instance destory direct

      confirmDialogInstance = null;
      div.parentNode.removeChild(div);
    }

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var triggerCancel = args.some(function (param) {
      return param && param.triggerCancel;
    });

    if (config.onCancel && triggerCancel) {
      config.onCancel.apply(config, args);
    }

    for (var i = 0; i < destroyFns.length; i++) {
      var fn = destroyFns[i];

      if (fn === close) {
        destroyFns.splice(i, 1);
        break;
      }
    }
  }

  function close() {
    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    currentConfig = confirm_objectSpread(confirm_objectSpread({}, currentConfig), {}, {
      visible: false,
      afterClose: destroy.bind.apply(destroy, [this].concat(args))
    });
    update(currentConfig);
  }

  function render(props) {
    confirmDialogProps.props = props;
    var V = base["a" /* default */].Vue || external_vue_default.a;
    return new V({
      el: el,
      parent: config.parentContext,
      data: function data() {
        return {
          confirmDialogProps: confirmDialogProps,
          vIf: true
        };
      },
      render: function render() {
        var h = arguments[0];

        var cdProps = confirm_objectSpread({}, this.confirmDialogProps); // 修复组件直接销毁后导致的过渡动画消失的问题


        return this.vIf ? h(confirm_dialog, cdProps) : null;
      }
    });
  }

  confirmDialogInstance = render(currentConfig);
  destroyFns.push(close);
  return {
    destroy: close,
    update: update
  };
}

/* harmony default export */ var modal_confirm = (confirm_confirm);
// CONCATENATED MODULE: ./src/components/modal/index.jsx
function components_modal_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function components_modal_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { components_modal_ownKeys(Object(source), true).forEach(function (key) { components_modal_defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { components_modal_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function components_modal_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }



 // import "./style/index.scss";

var modal_info = function info(props) {
  var config = components_modal_objectSpread({
    type: "info",
    icon: function icon(h) {
      return h("meg-icon", {
        attrs: {
          name: "megui-fill-warn"
        },
        "class": "meg-modal-warn-icon",
        style: "transform: rotate( 180deg );"
      });
    },
    okCancel: false
  }, props);

  return modal_confirm(config);
};

var modal_success = function success(props) {
  var config = components_modal_objectSpread({
    type: "success",
    icon: function icon(h) {
      return h("meg-icon", {
        attrs: {
          name: "megui-fill-check-circle",
          color: "#00C172"
        },
        "class": "meg-modal-success-icon"
      });
    },
    okCancel: false
  }, props);

  return modal_confirm(config);
};

var modal_error = function error(props) {
  var config = components_modal_objectSpread({
    type: "error",
    icon: function icon(h) {
      return h("meg-icon", {
        attrs: {
          name: "megui-fill-close-circle",
          color: "#E53635"
        },
        "class": "meg-modal-error-icon"
      });
    },
    okCancel: false
  }, props);

  return modal_confirm(config);
};

var modal_warning = function warning(props) {
  var config = components_modal_objectSpread({
    type: "warning",
    icon: function icon(h) {
      return h("meg-icon", {
        attrs: {
          name: "megui-fill-warn",
          color: "#FF8E27"
        },
        "class": "meg-modal-warn-icon"
      });
    },
    okCancel: false
  }, props);

  return modal_confirm(config);
};

var components_modal_confirm = function confirmFn(props) {
  var config = components_modal_objectSpread({
    type: "confirm",
    okCancel: true,
    icon: function icon(h) {
      return h("meg-icon", {
        attrs: {
          name: "megui-fill-warn"
        },
        "class": "meg-modal-warn-icon"
      });
    }
  }, props);

  return modal_confirm(config);
};

modal.info = modal_info;
modal.success = modal_success;
modal.error = modal_error;
modal.warning = modal_warning;
modal.warn = modal_warning;
modal.confirm = components_modal_confirm;

modal.destroyAll = function destroyAllFn() {
  while (destroyFns.length) {
    var close = destroyFns.pop();

    if (close) {
      close();
    }
  }
};
/* istanbul ignore next */


modal.install = function (Vue) {
  Vue.use(base["a" /* default */]);
  Vue.component(modal.name, modal);
};

/* harmony default export */ var components_modal = __webpack_exports__["default"] = (modal);

/***/ })

}]);